module.exports = __webpack_public_path__ + "img/P2-C3.64a3c808.svg";